import { capturePlaybackEvent } from './dataLayer';

export enum ASSET_TYPES {
  VIDEO = 'Video',
  AUDIO = 'Audio',
}

export type TypeMuxPlaybackEventProperties = {
  title: string | undefined;
  type: ASSET_TYPES.VIDEO | ASSET_TYPES.AUDIO;
  viewerId: string; // user uuid for signed playback, anonymous otherwise
  playbackServiceId?: string;
  isSigned: boolean;
  duration: number;
};

type HandlerFunctionMap = {
  [key: string]: () => void;
};

export function generateMuxPlaybackEvents(
  properties: TypeMuxPlaybackEventProperties,
  handlers: HandlerFunctionMap = {},
  setIsVideoPlaying?: (bool: boolean) => void,
) {
  return {
    onLoadStart: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
    onLoadedData: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
    onPlay: (e: Event) => {
      capturePlaybackEvent(e, properties, handlers[e.type]);
      if (setIsVideoPlaying) setIsVideoPlaying(true);
    },
    onPause: (e: Event) => {
      capturePlaybackEvent(e, properties, handlers[e.type]);
      if (setIsVideoPlaying) setIsVideoPlaying(false);
    },
    onEnded: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
    onSeeked: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
    onVolumeChange: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
    onRateChange: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
    onError: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
    onWaiting: (e: Event) =>
      capturePlaybackEvent(e, properties, handlers[e.type]),
  };
}
